import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';
import { TimelineView, type TimelineItem } from './TimelineView';

/** Timeline de INSPECCIONES (pestaña Intake del drawer): el reclamo llegó → se llenó con la
 *  aseguradora → visita pedida (quién) → agendada (inspector, ventana) → visita hecha
 *  (check-in/out con horas y mapa, reporte del inspector, video del ATR) o no-show →
 *  reagendas con quién las pidió y cuánto tardó en volverse a agendar. */
export function InspectionTimeline({ claimId }: { claimId: string }) {
  const { t } = useI18n();
  const [items, setItems] = useState<TimelineItem[] | null>(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get<{ items: TimelineItem[] }>(`/api/claims/${claimId}/inspection-timeline`)
      .then((r) => { if (alive) setItems(r.items); })
      .catch(() => { if (alive) setErr(true); });
    return () => { alive = false; };
  }, [claimId]);

  return (
    <TimelineView
      claimId={claimId}
      items={items}
      error={err}
      tPrefix="insTl"
      sendDept="supplements"
      sendRecipients={[]}
      title={t('insTl.title')}
      subtitle={t('insTl.subtitle')}
      emptyText={t('insTl.empty')}
    />
  );
}
